import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid, Box} from '@mui/material';
import apiCall, {setUserToken} from '@/utils/api';
import Loader from '@/shared/Loader';
import MaintenanceInterventions from 'src/containers/FdcMilanoMaintenanceInterventions/Charts/MaintenanceInterventions';

import './styles.scss';

const FdcMilanoMaintenanceInterventions = () => {
    const [searchParams] = useSearchParams();
    const container = searchParams.get('container_id');
    const scheduledMaintenanceSurvey = searchParams.get('scheduled_maintenance_survey');
    const maintenanceCarriedOutSurvey = searchParams.get('maintenance_carried_out_survey');

    setUserToken(searchParams.get('token') || '')

    const [loading, setLoading] = useState<boolean>(true);
    const [scheduledMaintenanceSubmissions, setScheduledMaintenanceSubmissions] = useState([]);
    const [maintenanceCarriedOutSubmissions, setMaintenanceCarriedOutSubmissions] = useState([]);

    const getSurvey = async () => {
        try {
            const responses = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: scheduledMaintenanceSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });
            const responsesMaintenanceCarriedOutSubmissions = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: maintenanceCarriedOutSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });

            setScheduledMaintenanceSubmissions(responses.data.submissions);
            setMaintenanceCarriedOutSubmissions(responsesMaintenanceCarriedOutSubmissions.data.submissions);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSurvey().then(() => setLoading(false));
    }, []);

    return (
        <Box p={2}>
            {
                !loading && (
                    <>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                            <Grid item xs={12}>
                                <MaintenanceInterventions
                                    scheduledMaintenanceSubmissions={scheduledMaintenanceSubmissions}
                                    maintenanceCarriedOutSubmissions={maintenanceCarriedOutSubmissions}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            }
            {
                loading && (
                    <Box className='loader-container'>
                        <Loader size={60}/>
                    </Box>
                )
            }
        </Box>
    )
}

export default FdcMilanoMaintenanceInterventions;